/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imagesDelete } from "../../funcs/imagesDelete.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteImageRequest$inboundSchema,
};

export const tool$imagesDelete: ToolDefinition<typeof args> = {
  name: "images-delete",
  description: `  Disable an image by its ID.
  
  Disabled images are still be accessible via their public URL, and cannot be assigned
  to products or line-items.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await imagesDelete(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(void 0, apiCall);
  },
};
